export const GET_BOOTH_MODELS = 'GET_BOOTH_MODELS';
export const GET_BOOTH_MODELS_BY_ID = 'GET_BOOTH_MODELS_BY_ID';
export const SET_BOOTH_MODELS = 'SET_BOOTH_MODELS';
export const SET_BOOTH_MODELS_BY_ID = 'SET_BOOTH_MODELS_BY_ID';